import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from '@angular/core';
import { first } from 'rxjs';

import { NotificationService } from '../services/notification.service';
import { NotificationInterface } from '../models/notification.interface';
import { SendItirenaryService } from '@services/send-itirenary.service';

/**
 * notification component
 */
@Component({
  selector: 'app-notification',
  templateUrl: './notification.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NotificationComponent {
  notifications: NotificationInterface[] = [];

  constructor(
    private cdr: ChangeDetectorRef,
    private service: NotificationService,
    private itirenaryService: SendItirenaryService,
  ) {
    this.service.pool.subscribe((notification) => {
      this.notifications.push(notification);
      this.cdr.detectChanges();
      setTimeout(() => {
        this.notifications.splice(this.notifications.indexOf(notification), 1);
        this.cdr.detectChanges();
      }, notification.time);
    });
  }

  /**
   * dismiss notification
   * @param notification - notification message
   */
  dismiss(event, notification: NotificationInterface): void {
    event.stopPropagation();
    this.notifications.splice(this.notifications.indexOf(notification), 1);
    this.cdr.detectChanges();

    // todo: should be moved into the separate component/method
    if (notification.notificationId) {
      this.itirenaryService.dismissItineraryNotification(notification.notificationId).pipe(first()).subscribe();
    }
  }

  openNotificationLink(event, notification: NotificationInterface): void {
    event.stopPropagation();

    // todo: should be moved into the separate component/method
    if (notification.link && notification.notificationId) {
      window.open(notification.link, '_blank');
      this.itirenaryService.dismissItineraryNotification(notification.notificationId).pipe(first()).subscribe();
    }
  }
}
